import { NgModule } from '@angular/core';
import { OverviewPreferencesService } from './services/overview-preferences.service';

@NgModule({
  providers: [OverviewPreferencesService],
})
export class OverviewModule {}
